import { MessageCircle, Mail } from 'lucide-react';
import { CONTACT } from './brand';

// « Vos retours » — en FRANÇAIS (testeurs francophones). Contact direct WhatsApp / email + réseaux.
export default function FeedbackBox({ lessonTitle = '' }) {
  const waText = `Bonjour JoSmartTech ! Voici mon retour sur l'application${lessonTitle ? ` (leçon : ${lessonTitle})` : ''} : `;
  const wa = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(waText)}`;
  const mail = `mailto:${CONTACT.email}?subject=${encodeURIComponent('Mes retours – JoSmartTech Academy')}&body=${encodeURIComponent("Bonjour,\n\nVoici mes suggestions pour améliorer l'application :\n\n")}`;

  return (
    <div className="mt-5 rounded-2xl border border-cyan-400/20 bg-cyan-500/[0.06] p-5" data-testid="feedback-box">
      <div className="flex items-center gap-2 text-cyan-200 font-bold">
        <MessageCircle size={18} />Vos retours
      </div>
      <p className="text-sm text-white/75 mt-1">
        Ton avis compte ! Dis-nous ce que tu aimes ou ce qu'on peut améliorer — ça nous aide à rendre l'application encore meilleure pour toi. 🙌
      </p>
      <div className="flex flex-col sm:flex-row gap-2 mt-3">
        <a href={wa} target="_blank" rel="noreferrer" data-testid="feedback-whatsapp"
          className="flex-1 bg-[#25D366] hover:bg-[#1ebe5a] text-slate-950 font-bold py-2.5 rounded-xl flex items-center justify-center gap-2 transition">
          <MessageCircle size={16} />Nous écrire sur WhatsApp
        </a>
        <a href={mail} data-testid="feedback-email"
          className="flex-1 bg-white/10 hover:bg-white/20 text-white font-bold py-2.5 rounded-xl flex items-center justify-center gap-2 transition">
          <Mail size={16} />Nous écrire par email
        </a>
      </div>
    </div>
  );
}
